import React from 'react';

// Reusable leaderboard section with Daily/Weekly/Monthly sub-boards.
// Props:
//   title     — section heading (e.g. "Reps", "Minutes", "Calories")
//   data      — { daily: { entries, max }, weekly: ..., monthly: ... }
//              OR for flat boards (e.g. Streaks): { entries: [...], max: N }
//   loading   — boolean, shows loading text when true
//   formatter — optional (entry) => string|node, custom display for entry values
function LeaderboardSection({ title, data, loading, formatter }) {
  const formatValue = formatter || ((entry) => entry.total);

  const renderList = (periodData) => {
    if (!periodData?.entries?.length) {
      return (
        <div className="empty-state">
          <p className="empty-state-headline">No activity yet</p>
          <p className="empty-state-subtitle">Log workouts to appear on the leaderboard</p>
        </div>
      );
    }
    return (
      <ul>
        {periodData.entries.map((entry, index) => (
          <li key={index}>
            {entry.name}: {formatValue(entry)}
            <div className="leaderboard-bar">
              <div className="leaderboard-fill" style={{ width: `${(entry.total / periodData.max) * 100}%` }}></div>
            </div>
          </li>
        ))}
      </ul>
    );
  };

  // Flat board (no daily/weekly/monthly) — e.g. Streaks
  const isFlat = data && !data.daily && Array.isArray(data.entries);

  return (
    <div className="leaderboard-section">
      <h3>{title}</h3>
      {loading ? (
        <p className="loading">Loading...</p>
      ) : isFlat ? (
        <div>{renderList(data)}</div>
      ) : (
        <>
          <div><h4>Daily</h4>{renderList(data.daily)}</div>
          <div><h4>Weekly</h4>{renderList(data.weekly)}</div>
          <div><h4>Monthly</h4>{renderList(data.monthly)}</div>
        </>
      )}
    </div>
  );
}

export default LeaderboardSection;
